const $ = window.jQuery;

$(function () {
    $(".sound-player").musicPlayer({
        volume: 10,
        elements: ['controls', 'time', 'progress', 'volume'],
        controlElements: ['skiprewind', 'play', 'skipforward'],
        timeElements: ['current'],
        playerAbovePlaylist: false,
    });
});


